"use client";

import React from "react";
import { BudgetEvolutionCard } from "./BudgetEvolutionCard";
import { FinancialReportCard } from "./FinancialReportCard";
import { AnnualBudgetExecutionCard } from "./AnnualBudgetExecutionCard";
export function TempBudgetView({
  institutionId
}: {
  institutionId: string;
}) {
  return <div className="flex flex-col gap-4" data-sentry-component="TempBudgetView" data-sentry-source-file="TempBudgetView.tsx">
      <div className="flex flex-col gap-4 desktop:flex-row desktop:gap-0">
        <div className="w-full desktop:w-3/4">
          <BudgetEvolutionCard institutionId={institutionId} data-sentry-element="BudgetEvolutionCard" data-sentry-source-file="TempBudgetView.tsx" />
        </div>
        <div className="w-full desktop:w-1/4 desktop:flex-1 desktop:pl-4">
          <FinancialReportCard institutionId={institutionId} data-sentry-element="FinancialReportCard" data-sentry-source-file="TempBudgetView.tsx" />
        </div>
      </div>
      <AnnualBudgetExecutionCard institutionId={institutionId} data-sentry-element="AnnualBudgetExecutionCard" data-sentry-source-file="TempBudgetView.tsx" />
    </div>;
}